import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Link } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import MuiImage from 'components/MuiExtras/MuiImage';
import { Formaters } from 'lib/Formarters';
import { ContentMetadataGetDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { CourseActions } from "views/Publication/Components/CourseModels";
import RenderVideo, { RenderVideoEventsProps } from 'views/Publication/Components/RenderVideo';
import { styles } from "./FileOrMetadataStyles";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    metadata: ContentMetadataGetDto;
    autoCompleteCourse?: boolean;
    onCustomAction?: (action: any) => Promise<boolean>;
}

type Props = IProps & RenderVideoEventsProps & WithStyles<typeof styles> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class RenderMetadata extends React.PureComponent<Props> {

    private divId: string;

    constructor(props: Props) {
        super(props);
        this.divId = new Date().getTime().toString();
    }

    private getDomainFromUrl(url: string): string {
        if (url) {
            var matches = url.match(/^https?\:\/\/(?!(?:www\.)?(?:youtube\.com|youtu\.be))([^\/:?#]+)(?:[\/:?#]|$)/i);
            return matches && matches[1];
        }
        return url;
    }

    private handleClickLink = () => {
        const {autoCompleteCourse, onCustomAction} = this.props;
        if (autoCompleteCourse)
            onCustomAction({ execution: { actionName: "complete" } as CourseActions });
    }

    private renderMetadata() {
        const { classes, metadata, ...rest } = this.props;

        if (metadata.provider == "YouTube" || metadata.provider == "Vimeo")
            return <RenderVideo metadata={metadata} {...rest} />;

        if (metadata.provider == "Twitter")
            return (
                <Link underline="none" href={metadata.url} target="_blank" title={this.props.t("Views.Publication.Components.RenderMetadata.ClickToViewText")}>
                    <div id={this.divId} className="twitter-post">
                        <Grid container className={classes.container} wrap="nowrap" justifyContent="center" alignItems="center">
                            <Grid item>
                                <FontAwesomeIcon icon={faTwitter} size="4x" color="rgb(29, 161, 242)" title={this.props.t("Views.Publication.Components.RenderMetadata.TwitterPost")} />
                            </Grid>

                            <Grid item xs>
                                <div dangerouslySetInnerHTML={{ __html: metadata.embedHtml }}></div>
                            </Grid>
                        </Grid>
                    </div>
                </Link>
            );

        if (metadata.provider == "website")
            return (
                <Link onClick={this.handleClickLink} underline="none" href={metadata.url} target="_blank" title={this.props.t("Views.Publication.Components.RenderMetadata.ClickToViewText")}>
                    <Grid container className={classes.container} spacing={1} wrap="nowrap">
                        {
                            metadata.image &&
                            <Grid item>
                                <MuiImage src={metadata.resizedThumbnailUrl ? metadata.resizedThumbnailUrl : metadata.image} size="auto" orientation="wide" />
                            </Grid>
                        }
                        <Grid item xs className={classes.columnMiddle}>
                            {metadata.title && <span className={classes.title}>{metadata.title}</span>}
                            {metadata.description && <div dangerouslySetInnerHTML={{ __html: metadata.description}}></div>}
                            <div className={classes.sourceUrl}>
                                {this.getDomainFromUrl(metadata.url)}
                            </div>
                        </Grid>
                    </Grid>
                </Link>
            );

        if (metadata.provider == "publication")
            return (
                <Link underline="none" href={metadata.url} target="_blank" title={this.props.t("Views.Publication.Components.RenderMetadata.ClickToViewPublicationText")}>
                    <Grid container className={classes.container} spacing={1} wrap="nowrap">
                        {
                            metadata.image &&
                            <Grid item>
                                <MuiImage src={metadata.resizedThumbnailUrl ? metadata.resizedThumbnailUrl : metadata.image} size="auto" orientation="wide" />
                            </Grid>
                        }
                        <Grid item xs className={classes.columnMiddle}>
                            {metadata.title && <span className={classes.title}>{metadata.title}</span>}
                            <Grid className={classes.author}>
                                {metadata.creationDate && <span>{Formaters.relativeTime(metadata.creationDate)}</span>}
                                {metadata.creationDate && metadata.authorName && <span>&nbsp;&ndash;&nbsp;</span>}
                                {metadata.authorName && <span>{metadata.authorName}</span>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Link>
            );

        return null;
    }

    public componentDidMount() {
        if (this.props.metadata.provider == "Twitter") {
            const el = document.getElementById(this.divId);
            el.querySelectorAll("a").forEach((n) => n.setAttribute("target", "_blank"));
        }
    }

    public render() {
        return this.renderMetadata();
    }
}

export default withTranslation()(withStyles(styles)(RenderMetadata));